import Backbone from 'backbone'
import _ from 'lodash'
import template from './threshold-colors.hbs'
import FormView from 'scoreboard/components/form-view'
import ThresholdColors from './threshold-colors'

/**
 * Renders the ThresholdColors view in a dialog. Used by places like chart maps
 * that only need the conditional color selector. For places that integrate
 * the conditional color selector into a larger dialog (like shape widgets),
 * use ThresholdColors
 */
const ThresholdColorsDialog = Backbone.View.extend({

	className: 'conditional-colors',

	tagName: 'form',

	/**
	 * Color Threshold Formatting #20258
	 *
	 * https://user-images.githubusercontent.com/1259395/48081253-946c6380-e1bd-11e8-89ed-5e08799cb259.png
	 *
	 * @param {Backbone.Model} options.model Model of ConditionalColor.kt
	 *
	 * @param {Object} options.aggregation Hash of aggregation data to aid in
	 * building the condition
	 *
	 * @param {String} [options.dataType] the data type of the thresholds
	 *
	 * @param {String} [options.currencyCode] the currency code of the
	 * thresholds
	 *
	 * @param {String} [options.precision] the decimal precision of the
	 * thresholds
	 *
	 * @param {String} options.title the title of the dialog
	 *
	 * @param {Boolean} [options.isGaugeWidget=false] if this dialog is for a
	 * dashboard gauge widget
	 */
	initialize: function(options = {}) {
		this.options = options

		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.html(template({title: this.options.title}))

		this.thresholdColorsView = new ThresholdColors(_.extend({
			formView: this.formView
		}, this.options))
		this.$('.dialog-body-content').append(this.thresholdColorsView.el)
		this.thresholdColorsView.render()

		this.formView.start()

		return this
	},

	submit: function() {
		this.trigger('done', this.model)
	},

	autoRemove: true

})

export default ThresholdColorsDialog

ThresholdColorsDialog.__filename__ = 'components/threshold-colors/threshold-colors-dialog.js'
